export const MEDIA_API = `v1/news-media`;
export const MEDIA_IMAGE_API = `v1/media/news-media/image`;
